import { render, staticRenderFns } from "./new-edit.vue?vue&type=template&id=9624ee6c&"
import script from "./new-edit.vue?vue&type=script&lang=js&"
export * from "./new-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports